import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import PropTypes from "prop-types";

import { ReactComponent as MagnifyingGlassSvg } from "../../../assets/icons/magnifying-glass.svg";

import "../../../styles/searchBox.scss";

const SearchBox = forwardRef(({ placeholder, onChange }, ref) => {
  const [value, setValue] = useState("");

  useImperativeHandle(ref, () => ({
    clearFilter: handleClearFilter,
  }));

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onChange(value);
  };

  const handleClearFilter = () => {
    setValue("");
  };

  return (
    <div className="search-box">
      <MagnifyingGlassSvg />
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          className="search-box__input"
          placeholder={placeholder}
          autoComplete="off"
          onChange={handleChange}
          value={value}
        />
      </form>
    </div>
  );
});

SearchBox.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

SearchBox.defaultProps = { placeholder: "", onChange: () => {} };

export default SearchBox;
